<template>
  <!-- 角色管理 -->
  <div class="roleManagement">
    <el-row class="tableHearInputBox" type="flex" justify="space-between">
      <el-col :span="6">
        <el-input
            v-model.trim="query.query"
            placeholder="请输入角色名称"
            style="width: 200px;margin-right:10px"
            @keyup.enter.native="tableLoad"
            @clear="
            query.query = '';
            tableLoad();
          "
            clearable
            suffix-icon="el-icon-search"
        ></el-input>
        <Debounce>
          <el-button size="small" @click="tableLoad">查询</el-button>
        </Debounce>
      </el-col>
      <el-button type="primary" size="small" @click="operatInfo(1)"
      >添加</el-button
      >
    </el-row>
    <el-table
        :data="tableList"
        tooltip-effect="dark"
        border
        ref="elTable"
        style="width: 100%;"
        :header-cell-style="$store.getters.getTableHeadStyle"
        v-loading="tableIsLoad"
        element-loading-text="加载中"
        :height="$store.getters.getTableHeight"
    >
      <el-table-column
          prop="roleName"
          label="角色名称"
          align="center"
      ></el-table-column>
      <el-table-column label="模块权限" align="center">
        <template slot-scope="scope">
          <el-button type="text" @click="operatInfo(3, scope.row)"
          >模块权限</el-button
          >
        </template>
      </el-table-column>
      <el-table-column label="关联用户" align="center">
        <template slot-scope="scope">
          <el-button type="text" @click="operatInfo(4, scope.row)"
          >关联用户</el-button>
        </template>
      </el-table-column>
      <el-table-column label="操作" align="center">
        <template slot-scope="scope">
          <el-button
              type="text"
              class="tableContentUpdateBut"
              @click="operatInfo(2, scope.row)"
          >修改</el-button>
          <span style="margin: 0px 5px;" >|</span>
          <el-button
              type="text"
              class="tableContentRemoveBut"
              :disabled="scope.row.systemRole"
              @click="operatInfo(0, scope.row)"
          >删除</el-button>
        </template>
      </el-table-column>
    </el-table>
    <Pagination
        :total="query.total"
        :page.sync="query.pageNum"
        :limit.sync="query.pageSize"
        class="pagination-content"
        @pagination="tableLoad"
    />
    <el-dialog
        custom-class="dailogComponents"
        :title="visibleType == 1?'添加':visibleType == 2 ? '修改':visibleType == 3 ?'查看':'关联用户'"
        :visible.sync="visible"
        :destroy-on-close="true"
        :close-on-click-modal="false"
        v-if="visible"
        :width="visibleType == 4?'650px':'800px'"
    >
      <AssocUser v-if="visibleType == 4" @reload="reload" :rowInfo="visibleObj"/>
      <RoleInfo v-else @reload="reload" :rowInfo="visibleObj" :operatType="visibleType" />

    </el-dialog>
  </div>
</template>

<script>
import RoleInfo from "./roleInfo";
import AssocUser from './assocUser'

export default {
  components: {
    RoleInfo,
    AssocUser,
  },
  data() {
    return {
      tableList: [],
      tableIsLoad: true,
      visible: false,
      visibleType: 0, //删除
      visibleObj: {},
      query: {
        query: "",
        pageNum: 1, // 当前页
        pageSize: 15, // 每页显示条数
        total: 1, //总条数
      },
    };
  },
  mounted() {
    this.tableLoad();
  },
  methods: {
    tableLoad() {
      this.$axios.post("/role/list", this.query).then((res) => {
        this.tableList = res.data.data.list;
        this.query.total = res.data.data.total;
        this.tableIsLoad=false;
      });
    },
    operatInfo(type, row) {
      this.visibleType = type;
      if (type === 0) {
        //删除
        let roleIds = [row.id];
        this.$dailog({
          title: "删除",
          context: "是否删除所选内容?",
          callbackFun: () => {
            this.$axios.delete("/role", { data: roleIds }).then((res) => {
              this.$message({ type: "success", message: '操作成功!' });
              this.tableLoad();
            });
          },
        });
      } else if (type === 1) {
        //添加
        this.visible = true;
      } else {
        //修改
        this.visible = true;
        this.visibleObj=row;
      }
    },
    reload() {
      this.visible = false;
      this.tableLoad();
    },
  },
};
</script>
